export const IMPORT_DATA_REQUEST  = 'IMPORT_DATA_REQUEST';
export const IMPORT_DATA_SUCCESS  = 'IMPORT_DATA_SUCCESS';
export const IMPORT_DATA_REQUEST_FAILURE  = 'IMPORT_DATA_REQUEST_FAILURE';